import { useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { notification } from 'antd';

import { ProductAttribute } from '../../../../api-client';
import { ProductApiClient } from '../../../../providers/api-provider';

export const useProductsDetail = () => {
    const {
        instance
    } = useMsal();

    const [productsAttributes, setProductsAttributes] = useState<ProductAttribute[]>();
    const [productsAttributesLoading, setProductsAttributesLoading] = useState<boolean>(false);

    const handleProductsAttributes = async (id: number) => {
        setProductsAttributesLoading(true);

        const clientApi = await ProductApiClient(instance);

        clientApi.getProductAttributes(id)
            .then((response) => {
                setProductsAttributes(response.data);
            })
            .catch((reason) => {
                setProductsAttributes([]);

                notification.error({
                    message: 'Unable to retrieve product attributes!',
                    description: 'Unable to retrieve product attributes.',
                    duration: 2
                });
            })
            .finally(() => {
                setProductsAttributesLoading(false);
            });
    }

    return {
        handleProductsAttributes,
        productsAttributes,
        productsAttributesLoading,
    }
}